import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../../constants/actionTypes";
import { logUI } from "../../../../../api/andyliticsApi";
import * as Tools from "../../../../../helpers/Tools";
import Spinner from '../../../../common/spinner';
import { Grid, TextFieldWithValidation as TextField, DropDownWithValidation as DropDown, PhoneNumberWithValidation as PhoneNumber, TextAreaWithValidation as TextArea, Radio } from "../../../../ecosystem/";
import { CareGapsButtons, CareGapsError, CareGapsHeading, CareGapsQuestionHeading } from '../../components';
import CareGapsConfirmationModal from "../../CareGapsConfirmationModal";
import * as procedureType from "../../../../../constants/textConstants";

class BloodPressureNo extends React.Component {
    constructor(props) {
        super(props);
        const { selectedNoCareGapReason, selectedNoCareGapData } = this.props;
        this.state = {
            selectedOption: selectedNoCareGapReason ? selectedNoCareGapReason.selectedReason : null,
            user: {
                name: selectedNoCareGapData && selectedNoCareGapData.facilityName || '',
                pMonth: selectedNoCareGapData && selectedNoCareGapData.procedureMonth || '', //monthNumber,
                pYear: selectedNoCareGapData && selectedNoCareGapData.procedureYear || '', //currentYear,
            },
            pNumber: selectedNoCareGapData ? selectedNoCareGapData?.phoneNumber : '',
            explain: selectedNoCareGapData ? selectedNoCareGapData?.description : '',
            isFailedToPost: false,
            nameValid: false,
            pMonthValid: false,
            pYearValid: false,
            formValid: selectedNoCareGapData && selectedNoCareGapData?.facilityName && selectedNoCareGapData?.procedureMonth && selectedNoCareGapData.procedureYear ? true : false,
        }
        this.radioLabels = {
            contactMe: 'This is an error, please contact me',
            alreadyScheduled: 'I have already scheduled an appointment',
            other: 'Other'
        };
    }

    componentDidMount() {
        const { careGapsSessionId, history } = this.props;
        logUI("MBHWeb.UI.BloodPressureNo.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        (history.location?.state?.prevClicked || history.location?.nextClicked) && this.setState({ formValid: true })
    }



    onChangeValue = (event) => {
        this.setState({ selectedOption: event.target.value, isFailedToPost: false });
    }

    formatSelectedReason = () => {
        const { selectedOption, pNumber, explain, user } = this.state;
        switch (selectedOption) {
            case this.radioLabels.contactMe:
                return { selectedReason: this.radioLabels.contactMe }
            case this.radioLabels.alreadyScheduled:
                return {
                    selectedReason: this.radioLabels.alreadyScheduled,
                    data: {
                        procedureMonth: user.pMonth,
                        procedureYear: user.pYear,
                        facilityName: user.name,
                        phoneNumber: pNumber
                    }
                }
            case this.radioLabels.other:
                return { selectedReason: this.radioLabels.other, description: explain }

            default:
                return null
        }
    }

    handleClickNext = (event) => {
        const { updateNoCareGapFlowSelectedData, history, careGapsSessionId } = this.props;
        const { pNumber, explain, user } = this.state;
        logUI(`MBHWeb.UI.BloodPressureNo.Next.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        //reset error state       
        this.setState({ isFailedToPost: false });
        let formatSelectedData = {
            procedureMonth: user.pMonth,
            procedureYear: user.pYear,
            facilityName: user.name,
            phoneNumber: pNumber,
            description: explain,
        }
        let formatSelectedReason = this.formatSelectedReason()
        let formatSelectedOption = { procedureType: "Blood Pressure", ...formatSelectedReason }
        updateNoCareGapFlowSelectedData(formatSelectedOption, formatSelectedData, procedureType.BP);
        history.push('/schedulemyBP/summary');

    }

    handleClickPrev = () => {
        const { history, careGapsSessionId, updateNoCareGapFlowSelectedData } = this.props;
        const { pNumber, explain, user, formValid } = this.state;

        logUI(`MBHWeb.UI.BloodPressureNo.Previous.Clicked`, new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId });
        history.push({ pathname: '/schedulemyBP', previousClicked: formValid })
        let formatSelectedData = {
            procedureMonth: user.pMonth,
            procedureYear: user.pYear,
            facilityName: user.name,
            phoneNumber: pNumber,
            description: explain,
        }
        let formatSelectedReason = this.formatSelectedReason()
        let formatSelectedOption = { procedureType: "Blood Pressure", ...formatSelectedReason }
        updateNoCareGapFlowSelectedData(formatSelectedOption, formatSelectedData, procedureType.BP)
    }

    handleUserInput(fieldName, value) {
        this.setState({
            user: {
                ...this.state.user,
                [fieldName]: value
            },
            [fieldName]: value,
        }, () => { this.validateField(fieldName, value) });
    }

    validateField(fieldName, value) {
        let nameValid = this.state.nameValid;
        let pMonthValid = this.state.pMonthValid;
        let pYearValid = this.state.pYearValid;

        switch (fieldName) {
            case 'name':
                nameValid = value.match(/^[A-Za-z][A-Za-z\'\-]+([\ A-Za-z][A-Za-z\'\-]+)*/);
                break;
            case 'pMonth':
                pMonthValid = value && value !== null ? true : false;
                break;
            case 'pYear':
                pYearValid = value && value !== null ? true : false;
                break;
            default:
                break;
        }
        this.setState({
            nameValid: nameValid,
            pMonthValid: pMonthValid,
            pYearValid: pYearValid,
        }, this.validateForm);
    }

    validateForm() {
        const { nameValid, pMonthValid, pYearValid, user } = this.state;
        this.setState({
            formValid: (nameValid || user.name) && (pMonthValid || user.pMonth) && (pYearValid || user.pYear)
        });
    }

    render() {
        const { selectedOption, user, pNumber, explain, isFailedToPost, formValid } = this.state;
        const subHeading = "Tell us why you don't need a blood pressure check and we will get your medical record up to date.";
        const options = Object.values(this.radioLabels);
        const { postCareGapDataPending } = this.props;

        return (
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Update your history"
                            description={subHeading}
                        />
                        <CareGapsQuestionHeading question="What is the reason you don’t need a blood pressure check?" />

                        {postCareGapDataPending && <Spinner />}

                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                {isFailedToPost && !postCareGapDataPending && <CareGapsError />}

                                <div className="care-gaps-radio-container">
                                    {options && options.map((option, index) => {
                                        return (

                                            <Radio
                                                label={option}
                                                selected={selectedOption}
                                                handleOnclick={this.onChangeValue}
                                                disabled={false}
                                                index={index}
                                                key={index}
                                                variant="select"
                                                optionsLength={options.length}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        {selectedOption === this.radioLabels.other ?
                            <div className="row">

                                <div className="col-12 col-lg-8 col-xl-6">
                                    <TextArea
                                        label="Could you explain why?"
                                        rows="4"
                                        maxLength={500}
                                        value={explain}
                                        id="explain"
                                        name="explain"
                                        onChange={(e) => { this.handleUserInput('explain', e.target.value); }}
                                    />
                                </div>
                            </div>
                            :
                            selectedOption === this.radioLabels.alreadyScheduled ?
                                <div className="row">
                                    <div className="col-12 col-lg-8 col-xl-6">
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <DropDown
                                                    label="Choose month"
                                                    options={Tools.getMonths()}
                                                    id="pMonth"
                                                    name="pMonth"
                                                    onChange={(e) => { this.handleUserInput('pMonth', e.target.value); }}
                                                    value={user.pMonth}
                                                    required
                                                />
                                            </div>
                                            <div className="col-xl-6">
                                                <DropDown
                                                    label="Choose year"
                                                    options={Tools.getYears()}
                                                    id="pYear"
                                                    name="pYear"
                                                    onChange={(e) => { this.handleUserInput('pYear', e.target.value); }}
                                                    value={user.pYear}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <TextField
                                                    label="Facility name"
                                                    id="name"
                                                    name="name"
                                                    value={user.name}
                                                    onChange={(e) => { this.handleUserInput('name', e.target.value); }}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <PhoneNumber
                                                    label="Facility phone number"
                                                    id="pNumber"
                                                    name="pNumber"
                                                    value={pNumber}
                                                    onChange={(e) => { this.handleUserInput('pNumber', e.target.value); }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                null

                        }

                        <CareGapsButtons
                            prev={{
                                onClick: () => this.handleClickPrev()
                            }}
                            next={{
                                disabled: selectedOption === this.radioLabels.alreadyScheduled ? !formValid : selectedOption === null,
                                onClick: () => this.handleClickNext()
                            }}
                        />
                    </div>
                </div>
                <CareGapsConfirmationModal careGapsType="schedulemyBP" />
            </Grid>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        selectedNoCareGapReason: state.careGap.selectedNoCareGapReason,
        history: state.session.history,
        postCareGapDataPending: state.careGap.postCareGapDataPending,
        careGapsSessionId: state.careGap.careGapsSessionId,
        selectedNoCareGapData: state.careGap.selectedNoCareGapData,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateNoCareGapFlowSelectedData: (reason, selectedData, procedureType) => dispatch({ type: types.UPDATE_NO_CAREGAP_FLOW_SELECTED_DATA, reason, selectedData, procedureType }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BloodPressureNo);
